<template>
  <div class="container">
    <h4 class="title is-4">Evaluators By Status</h4>
    <div class="field has-addons">
      <div class="control is-expanded">
        <input class="input" v-model="filters.name" @keyup.enter="refreshData()" />
      </div>
      <div class="control">
        <button class="button" @click="refreshData()" @keyup.enter="refreshData()">Search</button>
      </div>
    </div>
    <div class="level">
      <div class="level-left">
        <div class="level-item">
          <div class="select" style="margin-right: 5px">
            <select v-model="filters.pageSize" @change="refreshData()">
              <option :value="20">20 per page</option>
              <option :value="50">50 per page</option>
              <option :value="100">100 per page</option>
              <option :value="100">250 per page</option>
              <option :value="999999">All results</option>
            </select>
          </div>
          <div class="select">
            <select v-model="filters.status" @change="refreshData()">
              <option :value="null">All</option>
              <option v-for="(status, value) in statuses" :key="value" :value="value">{{
                status
              }}</option>
            </select>
          </div>
        </div>
      </div>
      <div class="level-right">
        <button class="button" style="marginRight: 1rem;">
          <router-link 
            :to="{ name: 'StaffAddEvaluator' }"
          >Add Evaluator</router-link>
        </button>
        <button class="button" :disabled="!selectedEvaluators.length" @click="toggleModal">
          Bulk Update Selected Evaluators
        </button>
      </div>
    </div>
    <loading-box v-if="!dataLoaded"></loading-box>
    <div v-if="dataLoaded">
      <pagination
        :pagination-details="paginationDetails"
        @update="refreshData($event)"
      ></pagination>

      <div class="selection-details">
        <label class="label" style="marginRight: 0.5rem;">Select all on page</label>
        <input
          type="checkbox"
          class="checkbox"
          style="marginRight: 1rem;"
          v-model="selectPage"
          @change="toggleSelectPage"
        />
        <p v-if="selectedEvaluators.length">{{ selectedEvaluators.length }} selected</p>
      </div>

      <div v-if="updatingData">
        <div class="columns">
          <div class="column"></div>
          <div class="column is-half has-text-centered" style="margin-top: 150px">
            <i class="fa fa-refresh fa-spin fa-5x"></i>
          </div>
          <div class="column"></div>
        </div>
      </div>
      <table class="table is-fullwidth" v-if="!updatingData">
        <thead>
          <tr>
            <th></th>
            <th>Status</th>
            <th>Name</th>
            <th>Email</th>
            <th>Status</th>
            <th>Send Individual Email</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="evaluator in evaluators" :key="evaluator.id">
            <td>
              <input
                type="checkbox"
                class="checkbox"
                :value="evaluator"
                v-model="selectedEvaluators"
              />
            </td>
            <td>
              <span class="tag">{{ evaluator.oldStatus }}</span>
            </td>
            <td>
              <router-link 
                :to="{ name: 'EvaluatorDetail', params: { evaluatorId: evaluator.id } }"
                target="_blank"
              >{{ evaluator.fullName }}
              </router-link>
            </td>
            <td>{{ evaluator.email }}</td>

            <td>
              <div class="field has-addons">
                <div class="control">
                  <div class="select">
                    <select v-model="evaluator.status">
                      <option v-for="(status, value) in statuses" :key="value" :value="value">{{
                        status
                      }}</option>
                    </select>
                  </div>
                </div>
                <div class="control">
                  <button class="button" @click="updateStatus(evaluator)">
                    Save
                  </button>
                </div>
              </div>
            </td>
            <td>
              <button class="button" @click="sendEmailToEvaluator(evaluator)">
                Send Individual Email
              </button>
            </td>

          </tr>
        </tbody>
      </table>

      <div class="modal is-active" v-if="showModal">
        <div class="modal-background"></div>
        <div class="modal-card">
          <header class="modal-card-head">
            <p class="modal-card-title">
              Update the status of {{ selectedEvaluators.length }} evaluators
            </p>
            <button class="delete" aria-label="close" @click="toggleModal"></button>
          </header>
          <section class="modal-card-body">
            <div class="select">
              <select v-model="modalStatus">
                <option v-for="(status, value) in statuses" :key="value" :value="value">{{
                  status
                }}</option>
              </select>
            </div>
          </section>
          <footer class="modal-card-foot">
            <button
              class="button is-primary"
              @click="bulkUpdateStatus(selectedEvaluators, modalStatus)"
            >
              Submit
            </button>
            <button class="button" @click="toggleModal">Cancel</button>
          </footer>
        </div>
      </div>
    </div>
    <BulkEmailModal
        v-if="showModalEmail"
        :users="selectedEvaluators"
        @close="showModalEmail = !showModalEmail"
        @submit="refreshData()"
      />
  </div>
</template>

<script>
import User from '@/services/users'
import LoadingBox from '@/components/LoadingBox'
import Pagination from '@/components/Pagination'
import BulkEmailModal from '@/components/emails/BulkEmailModal'


import { getPaginationDataFromResponse } from '@/services/pagination'

export default {
  components: { LoadingBox, Pagination, BulkEmailModal },
  data() {
    return {
      dataLoaded: false,
      pendingSelected: true,
      updatingData: false,
      isLoading: false,
      searchQuery: '',
      evaluators: {},
      selectedEvaluators: [],
      paginationDetails: {},
      filters: {
        name: '',
        status: null,
        isEvaluator: true,
        pageSize: 50,
      },
      statuses: User.evaluatorStatuses,
      selectPage: false,
      showModal: false,
      showModalEmail: false,
      modalStatus: '',
    }
  },
  watch: {
    selectedEvaluators(newEvaluators) {
      if (newEvaluators.length !== this.evaluators.length) {
        this.selectPage = false
      }
    },
  },
  created() {
    this.updatingData = true
    this.refreshData()
  },
  methods: {
    toggleModal() {
      this.showModal = !this.showModal
    },
    toggleSelectPage() {
      if (this.selectPage) {
        this.selectedEvaluators = [...this.evaluators]
      } else {
        this.selectedEvaluators = []
      }
    },    
    sendEmailToEvaluator(evaluator) {
      //console.log("sendEmailToEvaluator");
      this.selectedEvaluators = [evaluator]
      this.showModalEmail = true
    },

    updateStatus(evaluator) {
      let newEvaluator = User.create(evaluator)
      let fields = ['status']
      User.api
        .update(newEvaluator, fields)
        .then(data => {
          this.evaluator = data
          this.$Alert.alert({
            type: 'success',
            message: `<p>Updated Status<p>`,
            timeout: 6000,
          })
          this.refreshData()
        })
        .catch(() => {
          this.$Alert.alert({
            type: 'error',
            message: `<p>Status update failed<p>`,
            timeout: 6000,
          })
        })
    },
    bulkUpdateStatus(evaluators, status) {
      const evaluatorIds = evaluators.map(e => e.id)
      User.api
        .bulkUpdateStatus(evaluatorIds, status)
        .then(response => {
          this.modalStatus = ''
          this.toggleModal()
          this.refreshData()
        })
        .catch(() => {
          this.$Alert.alert({
            type: 'error',
            message: `<p>Status update failed<p>`,
            timeout: 6000,
          })
        })
    },
    refreshData(page = null) {
      this.showModalEmail = false
      let dataFilters = {}
      if (page) {
        dataFilters = { ...this.filters, page: page }
      } else {
        dataFilters = { ...this.filters }
      }
      User.api.list({ filters: dataFilters }).then(data => {
        this.paginationDetails = getPaginationDataFromResponse(data)
        this.evaluators = data.results
        this.evaluators.forEach(evaluator => {
          evaluator.oldStatus = evaluator.status
        })
        this.updatingData = false
        this.dataLoaded = true
        this.selectedEvaluators = []
      })
    },
  },
}
</script>

<style scoped>
.tag {
  margin: 0 10px;
}

.fixed-width {
  word-wrap: break-word;
  width: 180px;
}

.is-success > .child-of-application-link {
  color: white;
}

.approve-button {
  margin: 0 5px;
}

.selection-details {
  display: flex;
  align-items: center;
  margin-top: 1.5rem;
}
</style>
